import { getMembership } from "./getMembership";

/**
 * getCurrentUser: Adding currentUser meta/calculations
 * @param {Object} currentUser
 * @returns {Object} currentUser
 */
export const getCurrentUser = currentUser => {
    if (!currentUser) return currentUser;

    const membership = getMembership(currentUser);

    return {
        ...currentUser,
        membership
    };
};
